import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from './views/Login';
import SiteSelect from './views/SiteSelect';
import CustomerFacing from './views/store-view/CustomerFacing';
//
//
import Dashboard from './views/dashboard/index';
//
//
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    { path: '/', component: Login, name: 'login',
      beforeEnter: (to, from, next) => {
        let cookie = (process.env.VUE_APP_COOKIE_NAME) ? process.env.VUE_APP_COOKIE_NAME : 'bearer';
        if (localStorage.getItem(cookie)) {
          next({
            path: '/dashboard'
          });
        }
        else {
          next();
        }
      }},
    { path: '/dashboard', name: 'dashboard', component: Dashboard },
    { path: '/stores', component: SiteSelect, name: 'stores' },
    { path: '/stores/:id', component: CustomerFacing, name: 'store' },
    {
      path: '*',
      redirect: '/'
    }
  ],
});

import store from './store/store';
router.beforeEach((to, from, next) => {
  if (['stores','store','dashboard'].includes(to.name)) {
    let cookie = (process.env.VUE_APP_COOKIE_NAME) ? process.env.VUE_APP_COOKIE_NAME : 'bearer';
    if (!localStorage.getItem(cookie)) {
      let query = to.query;
      query['redirect'] = to.path;
      next({
        path: '/login',
        query: query,
      });
    } else {
      store.dispatch('KEY_CHECK');
      next();
    }
  } else next();
});

export default router;